import { LuCheck } from "react-icons/lu";
import React from "react";
const ProgressBar = ({
  steps,
  currentStep,
  onStepClick,
  showLabels = true,
  variant = 'default',
  size = 'sm',
  hasProcessInfo = false
}) => {
  const totalSteps = steps.length;
  const progress = ((currentStep + 1) / totalSteps) * 100;

  const getSizeStyles = () => {
    switch (size) {
      case 'sm':
        return {
          stepCircle: 'w-8 h-8 text-xs',
          iconSize: 'w-4 h-4',
          fontSize: 'text-xs',
          progressBar: 'h-1',
          marginTop: '-mt-[19px]'
        };
      case 'lg':
        return {
          stepCircle: 'w-14 h-14 text-lg',
          iconSize: 'w-7 h-7',
          fontSize: 'text-base',
          progressBar: 'h-2.5',
          marginTop: '-mt-[34px]'
        };
      default:
        return {
          stepCircle: 'w-10 h-10 text-sm',
          iconSize: 'w-5 h-5',
          fontSize: 'text-sm',
          progressBar: 'h-1.5',
          marginTop: '-mt-[23px]'
        };
    }
  };

  const getVariantStyles = () => {
    switch (variant) {
      case 'rounded':
        return {
          stepCircle: 'rounded-full',
          progressBar: 'rounded-full',
        };
      case 'compact':
        return {
          stepCircle: 'rounded-lg',
          progressBar: 'rounded',
        };
      default:
        return {
          stepCircle: 'rounded-full',
          progressBar: 'rounded-full',
        };
    }
  };

  const sizeStyles = getSizeStyles();
  const variantStyles = getVariantStyles();

  const getStepStatus = (index) => {
    if (index < currentStep) return 'completed';
    if (index === currentStep) return 'current';
    return 'pending';
  };

  const getStepColors = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-500 text-white border-green-500';
      case 'current':
        return 'bg-blue-500 text-white border-blue-500 ring-4 ring-blue-100';
      default:
        return 'bg-gray-100 text-gray-500 border-gray-300';
    }
  };

  return (
    <div className="w-full mt-6">
      {/* Progress Bar Container */}
      <div className="relative">
        {/* Background Progress Bar */}
        <div
          className={`bg-gray-200 ${variantStyles.progressBar} ${sizeStyles.progressBar}`}
        >
          {/* Active Progress Bar */}
          <div
            className={`bg-gradient-to-r from-blue-500 to-blue-600 ${variantStyles.progressBar} ${sizeStyles.progressBar} transition-all duration-500 ease-out`}
            style={{ width: `${progress}%` }}
          />
        </div>

        {/* Steps Container */}
        <div className={`relative ${sizeStyles.marginTop}`}>
          <div className="flex justify-between">
            {steps.map((step, index) => {
              const status = getStepStatus(index);
              const colors = getStepColors(status);

              return (
                <div
                  key={step.id}
                  className="flex flex-col items-center relative"
                  style={{ width: `${100 / totalSteps}%` }}
                >
                  {/* Step Circle/Button */}
                  <button
                    onClick={() => onStepClick?.(index)}
                    disabled={status === 'pending' && !onStepClick}
                    className={`
                      ${sizeStyles.stepCircle}
                      ${variantStyles.stepCircle}
                      ${colors}
                      flex items-center justify-center
                      transition-all duration-300
                      ${status !== 'pending' ? 'cursor-pointer hover:scale-110' : 'cursor-not-allowed'}
                      shadow-md hover:shadow-lg
                      font-semibold
                    `}
                  >
                    {status === 'completed' ? (
                      <LuCheck className={sizeStyles.iconSize} />
                    ) : step.icon ? (
                      // clone the icon element and add className to it
                      React.cloneElement(step.icon, {
                        className: `${step.icon.props.className || ''} ${sizeStyles.iconSize} ${step.iconClassName || ''}`.trim()
                      })
                    ) : (
                      <span>{index + 1}</span>
                    )}
                  </button>

                  {/* Step Label */}
                  {showLabels && (
                    <div className="mt-3 text-center">
                      <div
                        className={`
                          ${sizeStyles.fontSize}
                          font-medium
                          ${status === 'current' ? 'text-blue-600' :
                            status === 'completed' ? 'text-green-600' : 'text-gray-500'}
                        `}
                      >
                        {step.title}
                      </div>
                      {step.description && variant !== 'compact' && (
                        <div className={`${sizeStyles.fontSize} text-gray-400 mt-1`}>
                          {step.description}
                        </div>
                      )}
                    </div>
                  )}

                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Progress Info */}
      {
        hasProcessInfo
        &&
        <div className="mt-6 text-center">
          <div className="text-sm text-gray-500">
            مرحله {currentStep + 1} از {totalSteps}
          </div>
          <div className="text-xs text-gray-400 mt-1">
            {Math.round(progress)}% کامل شده
          </div>
        </div>
      }
      <div className="mt-6">
        {
          steps.map((step,index) => {
            if (index == currentStep) {
              return (
                step.component
              )
            }
          })
        }
      </div>
    </div>
  );
};

export default ProgressBar;